/**
*
*   Search Button
*       - The Button Control for the Search in the Nav
*
**/
'use client';

import Image, { getPath } from '@/components/image';
import Player from '@vimeo/player';
import { useEffect, useRef } from 'react';


//Build the Element
export default function Banner({ children, className = '', image, video, tag = 'header', gradient = false, base = false, fullpage, parallax, offset, ...props }){

	const Tag = tag;

	//
	const classes = [ 'banner' , className ];

	//If it's a full page banner
	if( fullpage ) classes.push('fullpage');

	//The current video
	const $video = useRef(null);

	//The Banner
	const $banner = useRef(null);

/*
	//Current Video
	const [ video , setVideo ] = useState(false);


	//The Video
	useEffect(()=>{
		if( videos ){

			//Prepare the videos for queries
			const media = Object.keys( videos ).filter( key => !isNaN(key) ).sort( (a,b) => a - b );

			//On Resize, find the closest video
			const Resizer = () => {

				//Get States
				const size = window.innerWidth;
				const current = media.filter( key => key >= size );
				const $el = $video.current.querySelector('video');
				const time = ( $el ? $el.currentTime : 0 );

				if( $el ) $el.remove();

				//Get the video
				const video = ( current.length > 0 ? videos[ current[0] ] : videos[ media[ media.length - 1 ] ] );

				//Prepare the Player
				const player = Object.assign( document.createElement('video') , {
					poster:         getPath( video.replace( '.webm' , '.jpg' ) , base ),
					playsInline:    true,
					autoplay:       true,
					muted:          true,
					loop:           true
				});

				player.appendChild(
					Object.assign( document.createElement('source'), {
						src:    getPath( video , base ),
						type:   'video/webm'
					})
				);

				player.onload = () => {
					player.play();
				}

				$video.current.appendChild(player);

			};

			//Add the Event Listener
			window.addEventListener( 'resize' , Resizer );

			//Get the Current Video
			Resizer();

			//Cleanup
			return () => window.removeEventListener( 'resize' , Resizer );

		}
	},[]);
*/

	//Video Play features
	useEffect(()=>{
		if( $video.current ){

			const player = new Player( $video.current , {
				badge:      0,
				background: 1,
				controls:   0,
				autoplay:   1,
				loop:       1,
				autopause:  0,
				id:         video
			});

			player.ready().then( () => $video.current.classList.add('ready') );

		}
	},[ $video , video ]);

	//Banner Offset Height to show next child
	useEffect(()=>{
		if( $banner.current ){

			//On Resize
			const onResize = () => {

				//If we're offseting the height, get the next sibling's height
				const height = ( offset ? $banner.current.nextSibling.offsetHeight : 0 );

				//Get the height
				$banner.current.style.setProperty('--offset-height', `${ height  }px` );

			};

			//Run on resize
			window.addEventListener('resize', onResize);

			//Initialize
			onResize();

			//Remove on change
			return () => window.removeEventListener('resize', onResize);

		}
	},[ $banner ]);

	//Parallax Banner
	if( image && parallax )
		return (
			<Tag role="banner" className={ [ ...classes, 'parallax' ].join(' ') } {...props}>
				<div className="wrap">
					<div className="container">
						{ children }
					</div>
				</div>
				<div className="bg">
					<Image src={ image } base={ base } alt="" placeholder="blur" blurDataURL={image} fill />
					<div>
						<div style={{ backgroundImage: `url(${  getPath(image, base)  })` }}></div>
					</div>
				</div>
			</Tag>
		);

	//Standard Banner
	if( image )
		return (
			<Tag role="banner" ref={ $banner } className={ classes.join(' ') } {...props}>
				<div className="bg">
					<div className="container">
						{ children }
					</div>
				</div>
				<Image src={image} base={ base } alt="" placeholder="blur" blurDataURL={image} fill />
			</Tag>
		);

	if( video )
		return (
			<Tag role="banner" ref={ $banner } className={ classes.join(' ') } {...props}>
				{ children && (
					<div className="bg">
						<div className="container">
							{ children }
						</div>
					</div>
				)}
				<div className="video">
					<div className="wrapper" ref={ $video }>
						{/* Player loads here */}
					</div>
					<Image className="poster" src={ `https://vumbnail.com/${ video }.jpg` } alt="" placeholder="blur" blurDataURL={ `https://vumbnail.com/${ video }.jpg`  } fill />
				</div>
			</Tag>
		);

	//Basic Banner
	return (
		<Tag role="banner" ref={ $banner } className={ [ ...classes, 'empty' ].join(' ') } {...props}>
			<div className="container">
				{ children }
			</div>
		</Tag>
	);

}